export const fmtNum = n =>
  (n ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const fmtCurr = n =>
  '$' + (n ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const fmtCurrAbbrev = n => {
  if (n == null) return '$0';
  if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (Math.abs(n) >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
};

export const fmtDate = iso => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const fmtDateShort = iso => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
  });
};

export const STATUS_TAG = {
  GENERATED: 'tagBl',
  SENT: 'tagTl',
  PAID: 'tagGr',
  DRAFT: 'tagGy',
  OVERDUE: 'tagRd',
};

export const STATUS_LABEL = {
  GENERATED: 'Generated',
  SENT: 'Email Sent',
  PAID: 'Paid',
  DRAFT: 'Draft',
  OVERDUE: 'Overdue',
};
